var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
var Enter = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M17,5 C17.5522847,5 18,5.44771525 18,6 L18,7 L17,7 L17,6 L8,6 L8,19 L17,19 L17,18 L18,18 L18,19 C18,19.5522847 17.5522847,20 17,20 L8,20 C7.44771525,20 7,19.5522847 7,19 L7,6 C7,5.44771525 7.44771525,5 8,5 L17,5 Z M15.2074102,9.08859116 C15.3779198,8.97046961 15.6055116,8.97046961 15.7760212,9.08859116 L15.8452691,9.14644661 L15.9031246,9.2156945 C16.0212461,9.38620412 16.0212461,9.61379588 15.9031246,9.7843055 L15.8452691,9.85355339 L13.6987157,12 L21.9917157,12 L21.9917157,13 L13.6987157,13 L15.8452691,15.1464466 L15.9031246,15.2156945 C16.0381206,15.4105626 16.0188355,15.679987 15.8452691,15.8535534 C15.6717028,16.0271197 15.4022784,16.0464049 15.2074102,15.9114088 L15.1381623,15.8535534 L12.1523045,12.8676955 L12.0921348,12.7956777 C11.9692884,12.6183477 11.9692884,12.3816523 12.0921348,12.2043223 L12.1523045,12.1323045 L15.1381623,9.14644661 L15.2074102,9.08859116 Z" })));
};
Enter.displayName = 'Enter';
export default Enter;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Enter.js.map